import { FormTheme } from '@kanda-libs/ks-component-ts';
import type { FunctionComponent } from 'react';
import JobNotesField from '../../JobNotesField';
import WorkTypeField from '../WorkTypeField';

const Fields: FunctionComponent = function () {
  return (
    <FormTheme variant="emphasized">
      <WorkTypeField />
      <div className="border-b border-neutral-300 -mt-3 mb-2" />
      <JobNotesField />
    </FormTheme>
  );
};

export default Fields;
